export const SPECIALISATION_BADGE_BASE_CLASSES =
  'inline-flex items-center justify-center gap-[8px] px-[12px] py-[6px] rounded-[24px] leading-0 text-[14px] text-center whitespace-nowrap font-sans font-medium';

export const SPECIALISATION_BADGE_SM_BASE_CLASSES =
  'inline-flex items-center justify-center gap-1 px-[12px] py-[6px] rounded-2xl leading-none text-[11px] text-center whitespace-nowrap font-sans font-medium';

// Badge keeps the per-clinic light background tint, but the label is always the
// neutral dark (#262626) so it stays readable — matches Figma.
const SPECIALISATION_BADGE_COLOR_CLASSES = {
  code_medical_center: 'bg-code-medical-center-secondary text-[#262626]',
  'code-medical-center': 'bg-code-medical-center-secondary text-[#262626]',
  infertility_treatment_clinic: 'bg-infertility-clinic-secondary text-[#262626]',
  'infertility-clinic': 'bg-infertility-clinic-secondary text-[#262626]',
  family_clinic: 'bg-family-clinic-secondary text-[#262626]',
  'family-clinic': 'bg-family-clinic-secondary text-[#262626]',
  institute: 'bg-institute-secondary text-[#262626]',
};

const SPECIALISATION_BADGE_TOOLTIP_LABELS = {
  code_medical_center: 'Specjalizacja Centrum Medycznego CODE',
  'code-medical-center': 'Specjalizacja Centrum Medycznego CODE',
  infertility_treatment_clinic: 'Specjalizacja Kliniki Przyczynowego Leczenia Niepłodności',
  'infertility-clinic': 'Specjalizacja Kliniki Przyczynowego Leczenia Niepłodności',
  family_clinic: 'Specjalizacja Kliniki Zdrowia Rodziny',
  'family-clinic': 'Specjalizacja Kliniki Zdrowia Rodziny',
  institute: 'Specjalizacja Instytutu Genomiki i Medycyny Molekularnej',
};

export function specialisationBadgeTooltip(contextOrColorToken) {
  if (!contextOrColorToken) {
    return SPECIALISATION_BADGE_TOOLTIP_LABELS.code_medical_center;
  }

  return (
    SPECIALISATION_BADGE_TOOLTIP_LABELS[contextOrColorToken]
    || SPECIALISATION_BADGE_TOOLTIP_LABELS.code_medical_center
  );
}

export function specialisationBadgeColorClasses(contextOrColorToken) {
  if (!contextOrColorToken) {
    return SPECIALISATION_BADGE_COLOR_CLASSES.code_medical_center;
  }

  return (
    SPECIALISATION_BADGE_COLOR_CLASSES[contextOrColorToken]
    || SPECIALISATION_BADGE_COLOR_CLASSES.code_medical_center
  );
}

export function specialisationBadgeClasses({ siteContext = null, colorToken = null, size = 'default' } = {}) {
  const baseClasses = size === 'sm'
    ? SPECIALISATION_BADGE_SM_BASE_CLASSES
    : SPECIALISATION_BADGE_BASE_CLASSES;

  return `${baseClasses} ${specialisationBadgeColorClasses(colorToken || siteContext)}`;
}
